import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../services/api";
;
const initialState = {
  data: undefined,
  status: 'idle',
  error: undefined
};
export const fetchAllMedia = createAsyncThunk("BLOG/fetchAllMedia", async () => {
  try {
    const {
      data
    } = await api.get("/v2/media?_fields=media_details,id,post,alt_text,source_url&per_page=100&page=1");
    if (data) return data;
  } catch (err) {
    return err;
  }
});
export const fetchLatestPostsMedia = createAsyncThunk("BLOG", async ids => {
  try {
    const {
      data
    } = await api.get("/v2/media?_fields=media_details,id,post,alt_text,source_url&include=".concat(ids));
    if (data) return data;
  } catch (err) {
    return err;
  }
});
const {
  actions,
  reducer
} = createSlice({
  name: "BLOG/fetchAllMedia",
  initialState,
  reducers: {
    clearBlogMediaFetcher: state => {
      state.data = undefined;
      state.status = 'idle';
      state.error = undefined;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchAllMedia.pending, state => {
      state.data = null;
      state.status = 'pending';
    });
    builder.addCase(fetchAllMedia.fulfilled, (state, action) => {
      state.data = action.payload;
      state.status = 'fulfilled';
    });
    builder.addCase(fetchAllMedia.rejected, (state, action) => {
      state.data = null;
      state.error = action.payload;
      state.status = 'rejected';
    });
    builder.addCase(fetchLatestPostsMedia.pending, state => {
      state.data = null;
      state.status = 'pending';
    });
    builder.addCase(fetchLatestPostsMedia.fulfilled, (state, action) => {
      state.data = action.payload;
      state.status = 'fulfilled';
    });
    builder.addCase(fetchLatestPostsMedia.rejected, (state, action) => {
      state.data = null;
      state.error = action.payload;
      state.status = 'rejected';
    });
  }
});
export const {
  clearBlogMediaFetcher
} = actions;
export default reducer;